import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { AppWithProviders } from "./App";
import { PortalLoader } from "./components/PortalLoader";
import "./index.css";

function Bootstrap() {
  const path = window.location.pathname;
  const allowLoader = path === "/portal" || path === "/portal/";
  const [leaving, setLeaving] = useState(false);
  const [visible, setVisible] = useState(() => allowLoader && sessionStorage.getItem("portalLoaderSeen") !== "1");

  useEffect(() => {
    if (!visible) return;
    const startLeaving = window.setTimeout(() => setLeaving(true), 1200);
    const hide = window.setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem("portalLoaderSeen", "1");
    }, 1500);
    return () => {
      window.clearTimeout(startLeaving);
      window.clearTimeout(hide);
    };
  }, [visible]);

  return (
    <>
      {visible ? <PortalLoader leaving={leaving} /> : null}
      <AppWithProviders />
    </>
  );
}

const container = document.getElementById("portal-root");
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <Bootstrap />
    </React.StrictMode>
  );
}
